import { DataTable } from '@/components/ui/DataTable';
import type { AdminInvoice } from '@/types/admin.types';
import { formatCurrency, formatDateTime } from '@/utils/formatters';
import { createColumnHelper } from '@tanstack/react-table';
import { InvoiceStatusBadge } from './InvoiceStatusBadge';

const columnHelper = createColumnHelper<AdminInvoice>();

const columns = [
  columnHelper.accessor('invoiceNumber', {
    header: 'Facture',
    cell: (info) => <span className="font-medium text-neutral-900 dark:text-neutral-200">{info.getValue()}</span>,
  }),
  columnHelper.accessor('organisationName', {
    header: 'Organisation',
    cell: (info) => <span className="text-neutral-600 dark:text-neutral-400">{info.getValue()}</span>,
  }),
  columnHelper.accessor('amountHT', {
    header: 'HT',
    cell: (info) => <span className="text-neutral-700 dark:text-neutral-300">{formatCurrency(info.getValue())}</span>,
  }),
  columnHelper.accessor('amountTTC', {
    header: 'TTC',
    cell: (info) => <span className="font-medium text-neutral-900 dark:text-neutral-200">{formatCurrency(info.getValue())}</span>,
  }),
  columnHelper.accessor('status', {
    header: 'Statut',
    cell: (info) => <InvoiceStatusBadge status={info.getValue()} />,
  }),
  columnHelper.accessor('createdAt', {
    header: 'Date',
    cell: (info) => <span className="text-xs text-neutral-500">{formatDateTime(info.getValue())}</span>,
  }),
];

interface MonthlyBillingTableProps {
  data: AdminInvoice[];
  loading?: boolean;
}

export function MonthlyBillingTable({ data, loading }: MonthlyBillingTableProps) {
  return <DataTable columns={columns} data={data} loading={loading} emptyMessage="Aucune facture" />;
}
